module.exports = __webpack_public_path__ + "ar.no2.1a883301.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ar.no2.jpg
// module id = 5J56
// module chunks = 0